module.exports = "https://bin.bnbstatic.com/_next/static/images/vote-banner-7cde7d9c038b21977e8469127e10f1d6.png";